import React, { useCallback, useRef, useState } from 'react';

import { Container, MenuList, Item } from './styles';
import useOutsideClick from 'utils/hooks/useOutsideClick';

type OptionItem = {
  color: string;
  label: string;
  value: string;
  show: boolean;
};
interface DropDownBubbleProps {
  options: OptionItem[];
  selected?: OptionItem;
  disabled?: boolean;
  unclickable?: boolean;
  style?: any;
  onChange?: (value: OptionItem) => void;
}

const DropDownBubble: React.FC<DropDownBubbleProps> = ({
  options,
  selected,
  disabled,
  unclickable,
  onChange,
  ...rest
}: DropDownBubbleProps) => {
  /**
   * USE STATE
   */
  // const [, setData] = useState(selected);
  const [opened, setOpened] = useState(false);

  const menuListRef = useRef(null);

  useOutsideClick(menuListRef, () => {
    setOpened(false);
  });

  const changeSelected = useCallback(
    value => {
      console.log('aqui', value);
      // setData(value);
      !!onChange && onChange(value);
      setOpened(false);
    },
    [onChange],
  );

  return (
    <Container
      disabled={disabled}
      $unclickable={unclickable}
      $selectedBubbleColor={selected?.color}
      {...rest}
    >
      <button
        onClick={e => {
          e.stopPropagation();
          if (!disabled && !unclickable) setOpened(prevState => !prevState);
        }}
      >
        <span />
      </button>
      {opened && (
        <MenuList ref={menuListRef}>
          {options
            .filter(op => !!op.show)
            .map((op, index) => (
              <Item
                key={index}
                $bubbleColor={op.color}
                onClick={() => (disabled ? {} : changeSelected(op))}
              >
                <div>
                  <span>{op.label}</span>
                </div>
              </Item>
            ))}
        </MenuList>
      )}
    </Container>
  );
};

export default DropDownBubble;
